import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är skillnaden mellan stadigvarande och tillfälligt tillstånd?";
const SHORT_ANSWER = "Stadigvarande gäller löpande drift, tillfälligt en specifik tidsperiod. Kraven, avgifterna och provformat skiljer sig åt.";

export const Route = createFileRoute("/fraga/skillnad-stadigvarande-tillfalligt")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är skillnaden mellan stadigvarande och till…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Stadigvarande tillstånd kräver komplett lämplighetsprövning, längre kunskapsprov och årlig tillsynsavgift. Tillfälligt tillstånd har snabbare handläggning, lägre avgift och prövas mer förenklat – men du måste söka i god tid (minst 6–8 veckor före)."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/stadigvarande-vs-tillfalligt-serveringstillstand", label: "Stadigvarande vs tillfälligt – guide" }}
      related={[{"to": "/fraga/cateringtillstand-vad-innebar-det", "label": "Vad innebär ett cateringtillstånd?"}, {"to": "/fraga/kan-jag-anvanda-pausservering", "label": "Vad är pausservering och vem kan få det?"}, {"to": "/fraga/vad-ar-tillfalligt-tillstand", "label": "Vad är ett tillfälligt serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är skillnaden mellan stadigvarande och tillfälligt ti…" },
      { name: "description", content: "Stadigvarande gäller löpande drift, tillfälligt en specifik tidsperiod. Kraven, avgifterna och provformat skiljer sig åt." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/skillnad-stadigvarande-tillfalligt" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/skillnad-stadigvarande-tillfalligt" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/skillnad-stadigvarande-tillfalligt",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är skillnaden mellan stadigvarande och till…", url: "https://alkoholprovet.se/fraga/skillnad-stadigvarande-tillfalligt" },
      ]),
    ],
  }),
});
